import styled from 'styled-components';

import Icon from '@omilia/icon';
import { colors } from '@omilia/theme';

import {
  StyledDropdown as _StyledDropdown,
  StyledDropdownContent as _StyledDropdownContent,
  StyledHeaderIcon as _StyledHeaderIcon,
} from 'components/HeaderDropdownMenu/styled';

export const SDropdown = styled(_StyledDropdown)`
  &&& {
    .dropdown__trigger {
      padding: 3px 6px;
      display: flex;
      align-items: center;
      margin-right: 2px;

      :hover {
        background-color: rgba(255, 255, 255, 0.1);
        color: #c4d0f3;
        border-radius: 5px;
      }
    }
  }
`;

export const SDropdownContent = styled(_StyledDropdownContent)`
  &&& {
    right: -14px;
  }
`;

export const SHeaderIcon = styled(_StyledHeaderIcon)`
  font-size: 16px;
  line-height: 16px;
`;

export const SIcon = styled(Icon)`
  color: ${(props: { color?: string }) =>
    props.color ? props.color : colors.COLOR_BLUE_200};
  margin-top: 1px;
`;
